import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Grid,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { cssuseStyles } from "../e_billing-style";
import E_StatementOfAccount from "../service/e_statement-of-account";
import { store } from "../../../helpers/store";
import moment from "moment";
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { useSelector } from "react-redux";
import { adminService } from "../../../services/admin.service";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

let STATEMENT_OF_ACCOUNT_TITLE;
let CERTIFICATES_STATEMENT_OF_ACCOUNT;
let STATEMENT_OF_ACCOUNT_FROM_DATE_MINIMUM_ERROR_MESSAGE;
let STATEMENT_OF_ACCOUNT_DATE_MAXIMUM_ERROR_MESSAGE;
let STATEMENT_OF_ACCOUNT_TO_DATE_MINIMUM_ERROR_MESSAGE;
let STATEMENT_OF_ACCOUNT_DATE_RANGE_ERROR_MESSAGE;

export default function E_StatementOfAccountCerificate(props) {
  const { t: content, ready: contentReady } = useTranslation("content-PROFILE_MANAGMENT");
  const { t: labels, ready: labelsReady } = useTranslation("label-PROFILE_MANAGMENT");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [isDisable, setDisable] = useState(true);
  const [noContent, setNoContent] = useState(false);
  const [inputErrorFrom, setInputErrorFrom] = useState("");
  const [inputErrorTo, setInputErrorTo] = useState("");
  const [errorMessageFrom, seterrorMessageFrom] = useState("");
  const [errorMessageTo, seterrorMessageTo] = useState("");

  useEffect(() => {
    if (
      !fromDate ||
      !toDate ||
      fromDate.toString() == "Invalid Date" ||
      toDate.toString() == "Invalid Date" ||
      moment(toDate).isBefore(fromDate) ||
      moment().isBefore(fromDate) ||
      moment().isBefore(toDate) ||
      moment(fromDate).isBefore(accountStartDate)
    ) {
      setDisable(true);
    } else {
      setDisable(false);
      setInputErrorTo("");
      setInputErrorFrom("");
    }
  }, [fromDate, toDate]);

  const customClasses = cssuseStyles();
  let accountID = "";
  const {customerNumber} = useSelector((state) => state.meterDetails)
  //let accountStartDate = useSelector((state) => state?.meterDetails?.setUpDate);
  let meterDetails = useSelector((state) => state?.meterDetails);
  let accountStartDate = meterDetails?.getSaInfo?.saStartDate
  if (store.getState().meterDetails.accountId) {
    accountID = store.getState().meterDetails.accountId;
  } else {
    store.subscribe(() => {
      accountID = store.getState().meterDetails.accountId;
    });
  }
  const languageCode = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  const date = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.YEAR_DATE_FORMAT
  );
  const datePickerFormat=
  useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.E_DATE_PICKER_FORMAT
  );
  const downloadFormat=datePickerFormat.toLowerCase().replace("MM", "mm");
  const dateFormat = date.toLowerCase().replace("mm", "MM");
  const handleDateErrorFrom = (error) => {
    setInputErrorFrom(error)
  };

  const handleDateErrorTo = (error) => {
    setInputErrorTo(error)
  };
  
  useEffect(()=>{
    if (inputErrorFrom === 'Invalid Date Format' || inputErrorFrom.code === 'Invalid Date Format') {
      seterrorMessageFrom(labels("E_INAVLID_DATE_FORMAT"));
      return;
    }
    if (inputErrorFrom === 'Date should not be before minimal date' || inputErrorFrom.code === 'Date should not be before minimal date') {
      seterrorMessageFrom(STATEMENT_OF_ACCOUNT_FROM_DATE_MINIMUM_ERROR_MESSAGE);
      return;
    }
    if (inputErrorFrom === 'Date should not be after maximal date' || inputErrorFrom.code === 'Date should not be after maximal date') {
      seterrorMessageFrom(STATEMENT_OF_ACCOUNT_DATE_MAXIMUM_ERROR_MESSAGE);
      return;
    }
  },[inputErrorFrom,setInputErrorFrom,i18next.language])

  useEffect(()=>{
    if (inputErrorTo === 'Invalid Date Format' || inputErrorTo.code === 'Invalid Date Format') {
      seterrorMessageTo(labels("E_INAVLID_DATE_FORMAT"));
      return;
    }
    if (inputErrorTo === 'Date should not be before minimal date' || inputErrorTo.code === 'Date should not be before minimal date') {
      seterrorMessageTo(STATEMENT_OF_ACCOUNT_TO_DATE_MINIMUM_ERROR_MESSAGE);
      return;
    }
    if (inputErrorTo === 'Date should not be after maximal date' || inputErrorTo.code === 'Date should not be after maximal date') {
      seterrorMessageTo(STATEMENT_OF_ACCOUNT_DATE_MAXIMUM_ERROR_MESSAGE);
      return;
    }
  },[inputErrorTo,setInputErrorTo,i18next.language])

  if (contentReady) {
        STATEMENT_OF_ACCOUNT_FROM_DATE_MINIMUM_ERROR_MESSAGE = content("STATEMENT_OF_ACCOUNT_FROM_DATE_MINIMUM_ERROR_MESSAGE").answer;
        STATEMENT_OF_ACCOUNT_TITLE = content("STATEMENT_OF_ACCOUNT_FROM_DATE_MINIMUM_ERROR_MESSAGE").question;
        STATEMENT_OF_ACCOUNT_DATE_MAXIMUM_ERROR_MESSAGE = content("STATEMENT_OF_ACCOUNT_DATE_MAXIMUM_ERROR_MESSAGE").answer;
        STATEMENT_OF_ACCOUNT_TO_DATE_MINIMUM_ERROR_MESSAGE = content("STATEMENT_OF_ACCOUNT_TO_DATE_MINIMUM_ERROR_MESSAGE").answer;
        CERTIFICATES_STATEMENT_OF_ACCOUNT = content("CERTIFICATES_STATEMENT_OF_ACCOUNT").answer;
        STATEMENT_OF_ACCOUNT_DATE_RANGE_ERROR_MESSAGE = content("STATEMENT_OF_ACCOUNT_DATE_RANGE_ERROR_MESSAGE").answer;
  }
  return (
    <Card className={customClasses.backgroundCard}>
      <CardContent >
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <Typography
              variant="h6"
              component="h5"
              color="primary"
              align="center"
            >
              {STATEMENT_OF_ACCOUNT_TITLE}
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              dangerouslySetInnerHTML={{
                __html: CERTIFICATES_STATEMENT_OF_ACCOUNT,
              }}
            ></Typography>
          </Grid>
          <Grid item className={customClasses.dateRange}>
            <Grid container direction="column">
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid
                  container
                  direction="row"
                  className={customClasses.dateFields}
                >
                  <Grid item>
                    <Typography>{labelsReady?labels("STATEMENT_FROM_DATE"):""}<span className={customClasses.asterisk}>*</span></Typography>
                    <KeyboardDatePicker
                      allowKeyboardControl
                      margin="normal"
                      minDate={moment(accountStartDate, date).format(
                        date
                      )}
                      value={fromDate}
                      initialFocusedDate={moment(
                        accountStartDate,
                        date
                      ).subtract(1,"d").format(date)}
                      autoOk={true}
                      onChange={(date) => {
                        setFromDate(date);
                        setToDate(null);
                        setNoContent(false);
                        setInputErrorFrom("");
                        seterrorMessageFrom("");
                      }}
                      disableFuture={true}
                      clearable={true}
                      size="small"
                      format={datePickerFormat}
                      placeholder={downloadFormat}
                      onError={handleDateErrorFrom}
                      helperText={errorMessageFrom}
                      error={errorMessageFrom !== ''}
                      // minDateMessage={
                      //   STATEMENT_OF_ACCOUNT_FROM_DATE_MINIMUM_ERROR_MESSAGE
                      // }
                      // maxDateMessage={
                      //   STATEMENT_OF_ACCOUNT_DATE_MAXIMUM_ERROR_MESSAGE
                      // }
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      className={customClasses.textField}
                    />
                  </Grid>
                  <Grid item>
                    <Typography>{labelsReady?labels("STATEMENT_TO_DATE"):""}<span className={customClasses.asterisk}>*</span></Typography>
                    <KeyboardDatePicker
                      allowKeyboardControl
                      clearable={true}
                      autoOk={true}
                      minDate={moment(fromDate, date)}
                      disableFuture={true}
                      value={toDate}
                      onChange={(date) => {
                        setToDate(date);
                        setNoContent(false);
                        setInputErrorTo("");
                        seterrorMessageTo("");
                      }}
                      margin="normal"
                      size="small"
                      format={datePickerFormat}
                      placeholder={downloadFormat}
                      onError={handleDateErrorTo}
                      helperText={errorMessageTo}
                      error={errorMessageTo !== ''}
                      // minDateMessage={
                      //   STATEMENT_OF_ACCOUNT_TO_DATE_MINIMUM_ERROR_MESSAGE
                      // }
                      // maxDateMessage={
                      //   STATEMENT_OF_ACCOUNT_DATE_MAXIMUM_ERROR_MESSAGE
                      // }
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      className={customClasses.textField}
                    />
                  </Grid>
                </Grid>
              </MuiPickersUtilsProvider>
              <Grid item className={customClasses.downloadButton}>
                {noContent && (
                  <span className={customClasses.errorMessage}>
                    {STATEMENT_OF_ACCOUNT_DATE_RANGE_ERROR_MESSAGE}
                  </span>
                )}
                <span>
                  {accountID && (
                    <E_StatementOfAccount
                      label={labelsReady ? labels("DOWNLOAD_BUTTON") : ""}
                      isDisable={isDisable}
                      toDate={toDate}
                      fromDate={fromDate}
                      setFromDate={setFromDate}
                      setToDate={setToDate}
                      setNoContent={setNoContent}
                      isDialog={props.isDialog}
                      setOpen={props.setOpen}
                      title={`${customerNumber}${
                        labelsReady ? labels("PROFILE_CERTIFICATES_STATEMENT_OF_ACCOUNT_FILE_NAME") : ""
                      }${moment(new Date()).format("DD-MM-YYYY")}`}
                      accountID={accountID}
                    />
                  )}
                </span>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
